import * as types from "./types";

export const setSelectedTab = (value) => {
  return {
    type: types.SET_SELECTED_TAB,
    payload: value,
  };
};
